export const config = {
  baseURL: process.env.REACT_APP_BASE_URL,
  //baseURL: "http://localhost:3001" || "https://transport-back-1.onrender.com/",
};
